if (!customElements.get('mewo-search')) {
  customElements.define('mewo-search', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.dialog = this.querySelector('dialog');
      this.input = this.querySelector('input[type="search"]');
      this.initial = this.querySelector('[data-search-initial]');
      this.results = this.querySelector('[data-search-results]');
      this.status = this.querySelector('[data-search-status]');
      this.trigger = this.querySelector('[data-search-open]');
      this.trigger.addEventListener('click', event => {
        if (!this.dialog.showModal) return;
        event.preventDefault();
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.input.focus({ preventScroll: true });
      }, options);
      this.querySelector('[data-search-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.trigger.focus({ preventScroll: true });
      }, options);
      this.input.addEventListener('input', () => this.schedule(), options);
      this.input.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' && !this.results.hidden) {
          const first = this.results.querySelector('a');
          if (first) { event.preventDefault(); first.focus(); }
        }
      }, options);
      this.querySelectorAll('[data-search-term]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        this.input.value = link.dataset.searchTerm;
        this.input.focus();
        this.schedule();
      }, options));
    }
    disconnectedCallback() {
      this.events?.abort();
      this.request?.abort();
      clearTimeout(this.timer);
      if (this.dialog?.open) document.documentElement.style.overflow = this.previousOverflow || '';
      this.bound = false;
    }
    schedule() {
      clearTimeout(this.timer);
      this.request?.abort();
      this.revision = (this.revision || 0) + 1;
      const query = this.input.value.trim();
      if (!query) {
        this.initial.hidden = false;
        this.results.hidden = true;
        this.results.replaceChildren();
        this.results.removeAttribute('aria-busy');
        this.status.textContent = '';
        return;
      }
      this.initial.hidden = true;
      this.results.hidden = false;
      this.results.replaceChildren();
      this.results.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      this.timer = setTimeout(() => this.search(query, this.revision), 180);
    }
    async search(query, revision) {
      this.request = new AbortController();
      const url = new URL(this.dataset.url, location.origin);
      url.search = new URLSearchParams({
        q: query, section_id: 'mewo-search-results',
        'resources[type]': 'product', 'resources[limit]': '6',
        'resources[options][unavailable_products]': 'hide'
      });
      try {
        const response = await fetch(url, { signal: this.request.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (revision !== this.revision || !this.isConnected) return;
        const result = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-search-response]');
        if (!result) throw new Error('Missing search results');
        this.results.replaceChildren(result);
        this.status.textContent = result.dataset.resultMessage;
      } catch (error) {
        if (error.name === 'AbortError' || revision !== this.revision || !this.isConnected) return;
        const message = document.createElement('p');
        message.textContent = this.dataset.error;
        this.results.replaceChildren(message);
        this.status.textContent = this.dataset.error;
      } finally {
        if (revision === this.revision) this.results.removeAttribute('aria-busy');
      }
    }
  });
}
